import Vue from 'vue';
import Vuex from 'vuex';

import AuthModule from './modules/AuthModule';
import ClientsModule from './modules/ClientsModule';
import AgentsModule from './modules/AgentsModule';
import OrdersModule from './modules/OrdersModule';
import ConfigurationModule from './modules/ConfigurationsModule';
import SamplesModule from './modules/SamplesModule';
import UserModule from './modules/UserModule';
import AmcModule from './modules/AmcModule';
import SnackBarmodule from './modules/SnackBarModule';
import AdminsModule from './modules/AdminsModule';
import ClientContactsModule from './modules/ClientContactsModule';
import ClientDireccionesModule from './modules/ClientDireccionesModule';
import ClientDireccionesEnvioModule from './modules/ClientDireccionesEnvioModule';
import OffersModule from './modules/OffersModule';
import NotifyModule from './modules/NotifyModule';
import NotificationsModule from './modules/NotificationsModule';
import DocumentsModule from './modules/DocumentsModule';
import LaboratorioModule from './modules/LaboratorioModule';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules : {
        AuthModule,
        ClientsModule,
        AgentsModule,
        OrdersModule,
        ConfigurationModule,
        SamplesModule,
        UserModule,
        AmcModule,
        SnackBarmodule,
        AdminsModule,
        ClientContactsModule,
        ClientDireccionesModule,
        ClientDireccionesEnvioModule,
        OffersModule,
        NotifyModule,
        NotificationsModule,
        DocumentsModule,
        LaboratorioModule
    }
});


// WEBPACK FOOTER //
// ./src/store/store.js